var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var validateFormData = function (formData, data) {
    if (data) {
        for (var item in data) {
            var value = data[item];
            var key = Object.keys(value)[0];
            if (key == "matrix_Radio_Select_Array") {
                var subData = value[key].data;
                for (var subItem in subData) {
                    var subValue = subData[subItem];
                    var subKey = Object.keys(subValue)[0];
                    var ans = checkValidity(subKey, subValue, formData);
                    if (!ans.isValid) {
                        return ans;
                    }
                }
            }
            else {
                var ans = checkValidity(key, value, formData);
                if (!ans.isValid) {
                    return ans;
                }
            }
        }
    }
    else {
        for (var key in formData) {
            var value = formData[key];
            if ((value === null || value === void 0 ? void 0 : value.length) <= 0) {
                return {
                    isValid: false,
                    errorField: key,
                    errorMessage: "This field is required*",
                };
            }
        }
    }
    return { isValid: true };
};
export var checkValidity = function (key, value, formData) {
    var isRequired = value[key].required;
    if (isRequired) {
        var formValue = formData[key];
        if ((formValue === null || formValue === void 0 ? void 0 : formValue.length) <= 0) {
            return {
                isValid: false,
                errorField: key,
                errorMessage: "This field is required*",
            };
        }
        var maxLength = value[key].max_length;
        if (maxLength && (formValue === null || formValue === void 0 ? void 0 : formValue.length) > maxLength) {
            return {
                isValid: false,
                errorField: key,
                errorMessage: "This text limit exceeds*",
            };
        }
    }
    return { isValid: true };
};
/**
 * Generates random form data for questionnaire fields
 * @param data Array of question items
 * @returns Object containing form data with random values
 */
export var generateRandomFormData = function (data) {
    var formData = {};
    data.forEach(function (item) {
        if (!item)
            return;
        var key = Object.keys(item)[0];
        var field = item[key];
        if (!field)
            return;
        if (key === "matrix_Radio_Select_Array" && field.data) {
            field.data.forEach(function (el) {
                if (!el)
                    return;
                if (Array.isArray(el)) {
                    // Handle array type matrix radio
                    var matrixKey = el[0];
                    if (field.choices && field.choices.length > 0) {
                        var randomIndex = Math.floor(Math.random() * field.choices.length);
                        formData[matrixKey] = field.choices[randomIndex];
                    }
                }
                else {
                    // Handle object type matrix radio
                    var matrixKey = Object.keys(el)[0];
                    if (matrixKey) {
                        var matrixField = el[matrixKey];
                        if (matrixField.choices && matrixField.choices.length > 0) {
                            var randomIndex = Math.floor(Math.random() * matrixField.choices.length);
                            formData[matrixKey] = matrixField.choices[randomIndex];
                        }
                    }
                }
            });
        }
        else {
            switch (field.field_type) {
                case "RadioSelect":
                case "Select":
                case "MatrixRadioSelect":
                    if (field.choices && field.choices.length > 0) {
                        var randomIndex = Math.floor(Math.random() * field.choices.length);
                        formData[key] = field.choices[randomIndex];
                    }
                    break;
                case "CheckboxSelectMultiple":
                    if (field.choices && field.choices.length > 0) {
                        // Select a random number of choices (at least 1)
                        var numChoices = Math.floor(Math.random() * field.choices.length) + 1;
                        var selectedChoices = [];
                        // Create a copy of choices to randomly sample from
                        var availableChoices = __spreadArray([], field.choices, true);
                        for (var i = 0; i < numChoices; i++) {
                            if (availableChoices.length > 0) {
                                var randomIndex = Math.floor(Math.random() * availableChoices.length);
                                selectedChoices.push(availableChoices[randomIndex]);
                                availableChoices.splice(randomIndex, 1);
                            }
                        }
                        formData[key] = selectedChoices;
                    }
                    break;
                case "TextInput":
                    // Generate a random text response
                    formData[key] = "".concat(Math.floor(Math.random() * 1000));
                    break;
                default:
                    break;
            }
        }
    });
    return formData;
};
